import styled from 'styled-components';

export const EbonContainerError = styled.div`
    .error-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 44px auto;
        max-width: 600px;
        text-align: center;

        & h1 {
            margin-bottom: 16px;
            font-size: 25px;
            text-transform: uppercase;
            color: ${props => props.theme.primary};
        }

        & h1::after {
            display: none;
        }

        a {
            margin-top: 30px;
        }

        .reasons {
            margin: 20px 0 0;
            text-align: left;
        }

        p {
            margin-top: 20px;
        }

        .iban {
            text-align: center;

            p {
                margin-top: 0px;
            }

            .label {
                margin-top: 20px;
                font-weight: ${props => props.theme.boldWeight};
            }

            .small {
                margin-top: 15px;
            }
        }

        .conteneur-color {
            background-color: #f5f5f5f5;
            margin-top: 20px;
            padding: 20px;
            border-radius: 10px;

            p {
                margin-top: 0;
            }

            .info {
                margin-top: 15px;
                font-size: 12px;
                font-style: italic;
            }

            a {
                margin-top: 20px;
            }
        }

        .kyc {
            .bt {
                margin: 15px 0;
            }

            .info {
                margin-top: 0;
            }

            .ubble {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 5px;
                font-size: 12px;
            }
        }

        .loading {
            margin-top: 30px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/ErrorEbonPageStyle.js